import { CSS, StyleProps } from "@shared/primitive-components"

const HEIGHT = 472
const height = () => ({
  [`@media(min-height:${HEIGHT + 30}px)`]: {
    minHeight: `${HEIGHT}px`,
  },
})

export const root = () => ({
  "& .mdc-dialog--scrollable .mdc-dialog__content": {
    padding: 0,
  },
})

export const content = () => ({
  padding: 0,
  overflow: `hidden`,
  ...height(),
})

export const left = (props: StyleProps) => ({
  padding: props.theme.spacing(6),
  background: props.theme.palette.coal.dark,
  color: props.theme.palette.white,
  ...height(),
})

export const pageTitle = (props: StyleProps): CSS => ({
  color: props.theme.palette.grey.light,
  marginBottom: props.theme.spacing(2),
  "@media (max-width: 600px)": {
    lineHeight: `1rem`,
  },
})

export const title = (props: StyleProps): CSS => ({
  color: props.theme.palette.grey.light,
  marginBottom: props.theme.spacing(2),
  whiteSpace: `break-spaces`,
  "@media (max-width: 600px)": {
    fontSize: `1rem`,
  },
})

export const text = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(2),
  "@media (max-width: 600px)": {
    fontSize: `0.6rem`,
  },
})

export const right = (props: StyleProps) => ({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: `43%`,
  background: props.theme.palette.full.red,
  color: props.theme.palette.white,
  ...height(),
})

export const label = (props: StyleProps): CSS => ({
  ...props.theme.fonts.heading,
  fontSize: props.theme.fontSize.subtitle,
  "@media (max-width: 600px)": {
    fontSize: `1rem`,
  },
})

export const disconnected = (props: StyleProps) => ({
  padding: props.theme.spacing(6),
})

export const connected = (props: StyleProps): CSS => ({
  padding: props.theme.spacing(6),
  color: props.theme.palette.coal.dark,
  background: props.theme.palette.brand,
})

export const button = (props: StyleProps): CSS => ({
  margin: props.theme.spacing(2, 0),
  "@media (max-width: 600px)": {
    fontSize: `0.7rem`,
  },
})
